import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import React from 'react';
import { Button, Container } from 'react-bootstrap';
import { IconContext } from 'react-icons';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

type RoleFormProps = {
  tabOptions: string[];
  currentTabIndex: number;
  renderTab: () => React.ReactNode;
  onBack: () => void;
  onNext: () => void;
  result?: { type?: string; message?: string } | string | null;
  leftFirstLabel?: string;
  leftLabel?: string;
  rightLabel?: string;
  rightFinalLabel?: string;
  tabHeaderOptions?: { option: string }[];
};

export default function RoleForm({
  tabOptions,
  currentTabIndex,
  renderTab,
  onBack,
  onNext,
  result,
  leftFirstLabel = 'Return',
  leftLabel = 'Back',
  rightLabel = 'Next',
  rightFinalLabel = 'Submit',
  tabHeaderOptions,
}: RoleFormProps) {
  const headerOptions = tabHeaderOptions ?? tabOptions.map((option) => ({ option }));

  const resultObj =
    typeof result === 'object' && result !== null
      ? (result as {
          type?: string;
          message?: string;
        })
      : null;

  return (
    <Container fluid className="d-flex flex-column h-100">
      <div className="d-flex flex-row justify-content-between mt-2 flex-shrink-0">
        <Button
          className="d-flex flex-row align-items-center bg-primary rounded-1"
          onClick={onBack}
        >
          <div className="d-flex align-items-center">
            <IconContext.Provider value={{ size: '20' }}>
              <FaChevronLeft />
            </IconContext.Provider>
          </div>
          <div className="me-1 fs-6 gap-2">
            {currentTabIndex === 0 ? leftFirstLabel : leftLabel}
          </div>
        </Button>
        <Button
          className="d-flex flex-row align-items-center bg-primary rounded-1"
          onClick={onNext}
        >
          <div className="ms-1 fs-6 gap-2">
            {currentTabIndex === tabOptions.length - 1 ? rightFinalLabel : rightLabel}
          </div>
          {currentTabIndex !== tabOptions.length - 1 && (
            <div className="d-flex align-items-center">
              <IconContext.Provider value={{ size: '20' }}>
                <FaChevronRight />
              </IconContext.Provider>
            </div>
          )}
        </Button>
      </div>

      <div className="mt-2 d-none d-lg-block flex-shrink-0">
        <TabsHeader options={headerOptions} />
      </div>
      <div className="mt-3 d-block d-lg-none flex-shrink-0">
        <MobileTabsHeader options={headerOptions} />
      </div>

      <div className="d-flex flex-column flex-grow-1 overflow-hidden mt-3" style={{ minHeight: 0 }}>
        <div className="d-flex bg-base flex-grow-1 overflow-hidden" style={{ minHeight: 0 }}>
          {renderTab()}
        </div>
      </div>

      {result && (
        <div
          className="h4 fw-bold flex-shrink-0"
          style={{ color: resultObj?.type === 'success' ? 'green' : 'red' }}
        >
          {resultObj?.message ?? String(result)}
        </div>
      )}
    </Container>
  );
}
